import React from "react";
import CustomDropDown from "./CommonComponents/CustomDropdown";

const SelectClinic2 = ({
  options,
  defaultValue,
  noOptionsMessage,
  handleOnChange,
}) => {
  return (
    <CustomDropDown
      className="select_dropdownOptions"
      showSearch={false}
      placeholder={"Select Clinic"}
      options={options}
      // defaultValue={defaultValue}
      value={defaultValue}
      handleChange={handleOnChange}
      isSearchable={false}
      noOptionsMessage={noOptionsMessage}
    />
  );
};

export default SelectClinic2;
